import { render, staticRenderFns } from "./ProgressiveLensImageWithWireframe.vue?vue&type=template&id=fb825ae8&"
import script from "./ProgressiveLensImageWithWireframe.vue?vue&type=script&lang=js&"
export * from "./ProgressiveLensImageWithWireframe.vue?vue&type=script&lang=js&"
import style0 from "./ProgressiveLensImageWithWireframe.vue?vue&type=style&index=0&id=fb825ae8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports